<template>
	<div class="loading-container" v-if="isLoading">
		<div class="loading-spinner">
			<div class="spinner"></div>
		</div>
		<!-- 随机提示文字 + 淡入动画 -->
		<p class="loading-text" :key="currentTextIndex">
			{{ currentTipText }}
		</p>
	</div>
</template>

<script>
	export default {
		name: "LoadingAnimation",
		props: {
			isLoading: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				tipTexts: [
					"AI 正在梳理解题核心思路...",          // 初始思路构建
					"AI 正在拆解问题关键步骤...",          // 任务分解
					"AI 正在检索关联知识库知识点...",      // 知识调用
					"AI 正在验证公式/定理适用性...",        // 逻辑校验
					"AI 正在清洗输入数据异常值...",        // 数据处理
					"AI 正在构建中间推导过程...",          // 推理过程
					"AI 正在优化步骤衔接流畅度...",        // 表达优化
					"AI 正在检测逻辑矛盾点并修正...",      // 错误排查
					"AI 正在适配用户知识水平调整难度...",  // 个性化适配
					"AI 正在生成可视化辅助说明...",        // 输出形式拓展
					"AI 正在校验结果边界条件...",          // 边界测试
					"AI 正在整合跨学科知识点...",          // 知识融合
					"AI 正在回溯关键步骤确保完整性...",    // 完整性检查
					"AI 正在优化表达逻辑严谨性...",        // 严谨性提升
					"AI 正在剔除冗余计算过程...",          // 效率优化
					"AI 正在生成多语言版本解析...",        // 多语言支持
					"AI 正在补充相关案例辅助理解...",      // 理解增强
					"AI 正在动态调整推理策略提升速度...",  // 策略优化
					"AI 正在记录过程数据用于后续迭代...",  // 数据沉淀
					"AI 正在匹配学生历史偏好定制输出...",  // 个性化优化
					"AI 正在验证最终结论一致性...",        // 结果校验
					"AI 正在格式化输出结构提升可读性...",  // 格式美化
					"AI 正在调用专用模型深化分析...",      // 模型协同
					"AI 正在生成解题关键点摘要...",        // 核心提炼
					"AI 正在校准数值计算精度...",          // 精度优化
					"AI 正在排查潜在假设合理性...",        // 假设验证
					"AI 正在构建备选解决方案路径..."       // 方案多样性
				],
				currentTextIndex: 0, // 当前显示的文字索引
				textTimer: null // 文字切换定时器
			};
		},
		computed: {
			// 当前显示的提示文字
			currentTipText() {
				return this.tipTexts[this.currentTextIndex];
			}
		},
		watch: {
			isLoading: {
				handler(newVal) {
					if (newVal) {
						this.startTextSwitch();
					} else {
						this.clearTextTimer();
					}
				},
				immediate: true // 新增：初始渲染时就执行一次handler
			}
		},
		beforeDestroy() {
			// 组件销毁时清除定时器（避免内存泄漏）
			this.clearTextTimer();
		},
		methods: {
			// 启动文字切换
			startTextSwitch() {
				// 初始随机选一个文字
				this.currentTextIndex = Math.floor(Math.random() * this.tipTexts.length);
				// 清除旧定时器（避免重复创建）
				this.clearTextTimer();
				// 每3秒切换一次文字
				this.textTimer = setInterval(() => {
					// 循环切换索引
					this.currentTextIndex = (this.currentTextIndex + 1) % this.tipTexts.length;
					// 强制触发视图更新（关键：解决Vue响应式检测问题）
					this.$forceUpdate();
				}, 3000);
			},
			// 清除定时器
			clearTextTimer() {
				if (this.textTimer) {
					clearInterval(this.textTimer);
					this.textTimer = null;
				}
			}
		}
	};
</script>

<style scoped>
	.loading-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 30px 20px;
		color: #666;
	}

	.loading-spinner {
		margin-bottom: 16px;
	}

	.spinner {
		width: 40px;
		height: 40px;
		border: 4px solid #f0f5ff;
		border-top: 4px solid #1890ff;
		border-radius: 50%;
		animation: spin 1.2s linear infinite;
	}

	/* 转圈动画优化：更流畅的速度曲线 */
	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}

	.loading-text {
		font-size: 15px;
		font-weight: 500;
		color: #409eff;
		/* 文字淡入动画：切换时的过渡效果 */
		opacity: 0;
		animation: fadeIn 0.5s ease forwards;
	}

	/* 淡入动画 */
	@keyframes fadeIn {
		from { opacity: 0; transform: translateY(5px); }
		to { opacity: 1; transform: translateY(0); }
	}
</style>
